import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import purseService from "../purseAction";

const initialState = {
  stats: null,
  loading: false,
  error: false,
  success: false,
  message: null,
};

export const purseStatDetailsAction = createAsyncThunk(
  "purseStatDetailsAction",
  () => {
    return purseService.purseStats();
  }
);

//CREATE THE SLICE

export const purseStatDetailsSlice = createSlice({
  name: "purseStatDetails",
  initialState,
  reducers: {
    //non asynchronous reducers goes here
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.message = "";
      state.stats = {};
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(purseStatDetailsAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(purseStatDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.stats = action.payload;
      })
      .addCase(purseStatDetailsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.stats = null;
      });
  },
});

export const { reset } = purseStatDetailsSlice.actions;

export default purseStatDetailsSlice.reducer;
